import {
  FAILED_REQUEST,
  LOADING_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  SET_HERE_ABOUT_US_STATUS,
  TOGGLE_REMEMBER,
  UPDATE_MODAL_STATUS,
} from "../constants";

const INITIAL_STATE = {
  current: {},
  isLoading: false,
  isLoggedIn: false,
  rememberMe: false,
  isForceUpdate: true,
};

const loginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FAILED_REQUEST:
      return INITIAL_STATE;
    case SET_HERE_ABOUT_US_STATUS:
      return {
        ...state,
        current: {
          ...state.current,
          userReferralDetails: action.payload,
        },
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        current: action.payload,
        isLoading: false,
      };
    case TOGGLE_REMEMBER:
      return {
        ...state,
        rememberMe: !state.rememberMe,
      };
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;

    case UPDATE_MODAL_STATUS:
      return { ...state, isForceUpdate: action.payload };
    default:
      return state;
  }
};

export default loginReducer;
